module.exports = __webpack_public_path__ + "img/TinyTurtleTanks.ddcc9fa3.jpg";